<template>
  <b-form-group
    label="KDV Oranı"
    label-for="id_taxes"
  >
    <validation-provider
      #default="{ errors }"
      name="KDV Oranı"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_taxes"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="KDV Oranı"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'TaxesSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['taxes/dataList']
    },
    dataItem() {
      return this.$store.getters['servicePrices/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('taxes/getDataList')
    },
  },
}
</script>
